export default "__VITE_ASSET__BSV4HK1Y__"